import { render, staticRenderFns } from "./section-pulse-trend-chart.vue?vue&type=template&id=be523c88&scoped=true"
import script from "./section-pulse-trend-chart.vue?vue&type=script&lang=js"
export * from "./section-pulse-trend-chart.vue?vue&type=script&lang=js"
import style0 from "./section-pulse-trend-chart.vue?vue&type=style&index=0&id=be523c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be523c88",
  null
  
)

export default component.exports